import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import CkEditor from "../../Components/CkEditor";
import classnames from "classnames";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions

import { getContent as onGetContent, addNewContent as onAddNewContent, updateContent as onUpdateContent, deleteContent as onDeleteContent, resetContentState } from "../../store/content/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../Components/Common/ExportCSVModal";
import defaultImg from "../../assets/images/upload.png";

import { resetAgentState, getAgent } from "../../store/agent/action";
import { resetAgencyState, getAgency } from "../../store/agency/action";
import { resetContentCategoryState, getContentCategory } from "../../store/contentCategory/action";

import { api } from "../../config";
import ModalInputFile from "../../Components/ModalInputFile";
import handleValidDate from "../../helpers/utils/handleValidDate";
import { setBranchSelect, setCompanySelect } from "../../store/actions";

const typeSelectData = [
  {
    options: [
      { label: "Berita", value: "Berita" },
      { label: "Banner", value: "Banner" },
      { label: "Single Banner", value: "Single Banner" },
      { label: "Bantuan", value: "Bantuan" },
      { label: "About", value: "About" },
      { label: "Term", value: "Term" },
      { label: "Privacy", value: "Privacy" },
      { label: "Contact Us", value: "Contact Us" },
      { label: "KPR", value: "KPR" },
      { label: "Location", value: "Location" },
    ],
  },
];

const Content = (props) => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [logo, setLogo] = useState(defaultImg);
  const [assetFiles, setAssetFiles] = useState([]);
  const [originalFiles, setOriginalFiles] = useState([]);
  const dispatch = useDispatch();
  const refEditor = useRef();
  const [mediaType, setMediaType] = useState("");

  const {
    clientSelected,
    companySelected,
    branchSelected,
    userData,
    userType,
    userRole,
    contents,
    contentLoading,
    isContentCreated,
    isContentSuccess,
    loading,
    error,

    companies,
    companyLoading,
    clients,
    clientLoading,
    branches,
    branchLoading,
    contentCategories,
    contentCategoryLoading,
    agents,
    agentLoading,
    agencys,
    agencyLoading,
  } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    contents: state.Content.contents,
    contentLoading: state.Content.loading,
    isContentCreated: state.Content.isContentCreated,
    isContentSuccess: state.Content.isContentSuccess,
    loading: state.Content.loading,
    error: state.Content.error,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    contentCategories: state.ContentCategory.contentCategories,
    contentCategoryLoading: state.ContentCategory.loading,
    agents: state.Agent.agents,
    agentLoading: state.Agent.loading,
    agencys: state.Agency.agencys,
    agencyLoading: state.Agency.loading,
  }));

  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [agencyList, setAgencyList] = useState([]);
  const [contentCategoryList, setContentCategoryList] = useState([]);

  const [contentList, setContentList] = useState([]);
  const [content, setContent] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [status, setStatus] = useState([]);
  const [isDisabledUserType, setIsDisabledUserType] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);

  const statusData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const onClickDelete = (content) => {
    setContent(content);
    setDeleteModal(true);
  };

  const handleDeleteContent = () => {
    if (content) {
      dispatch(onDeleteContent(content));
      setDeleteModal(false);
    }
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = assetFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setAssetFiles(newState);
    } else {
      const index = assetFiles.findIndex((fl) => fl.filename === file.filename);

      setAssetFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };
  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  useEffect(() => {
    var data = [];
    var opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (branches.length > 0) {
      setBranchList(data);
    }
  }, [branches]);

  useEffect(() => {
    var data = [];
    var opt = [];
    agents.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (agents.length > 0) {
      setAgentList(data);
    }
  }, [agents]);

  useEffect(() => {
    var data = [];
    var opt = [];
    agencys.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (agencys.length > 0) {
      setAgencyList(data);
    }
  }, [agencys]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(contentCategories)) {
      var data = [];
      var opt = [];
      contentCategories.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setContentCategoryList(data);
    }
  }, [contentCategories]);

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredContent = contents;
      if (type !== "all") {
        filteredContent = contents.filter((content) => content.content_status.name === type);
      }
      setContentList(filteredContent);
    }
  };

  useEffect(() => {
    setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
    setContentList([]);
    dispatch(resetContentState());
    dispatch(
      onGetContent({
        type: props.name,
      })
    );
    dispatch(resetAgencyState());
    dispatch(getAgency());
    dispatch(resetAgentState());
    dispatch(getAgent());
  }, [props]);

  useEffect(() => {
    if (!isEmpty(contents)) {
      let filteredContent = contents;
      if (activeTypeTab !== "all") {
        filteredContent = contents.filter((content) => content.content_status.name === activeTypeTab);
      }
      setContentList(filteredContent);
      // setContentList(contents);
      setIsEdit(false);
    }
  }, [contents]);

  // useEffect(() => {
  //   if (!isEmpty(contents)) {
  //     setContent(contents);
  //     setIsEdit(false);
  //   }
  // }, [contents]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setContent(null);
      setLogo(defaultImg);
      setContentCategoryList([]);

      dispatch(resetContentCategoryState());
      validation.resetForm();
      validation.setErrors({});
    } else {
      dispatch(getContentCategory());
      setModal(true);
    }
  }, [modal]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const handleSelectFile = (file) => {
    switch (mediaType) {
      case "image":
        validation.setFieldValue("image", file.filename);
        break;
      case "files":
        setAssetFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
      case "imageVarian":
        validation.setFieldValue("imageVarian", file.filename);
        break;
      default:
        setAssetFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
    }

    toggleMedia();
  };

  const checkType = (val) => {
    switch (val) {
      case "Berita":
        return {
          label: "Berita",
          value: "Berita",
        };
      case "Banner":
        return {
          label: "Banner",
          value: "Banner",
        };
      case "Single Banner":
        return {
          label: "Single Banner",
          value: "Single Banner",
        };
      case "Bantuan":
        return {
          label: "Bantuan",
          value: "Bantuan",
        };

      case "About":
        return {
          label: "About",
          value: "About",
        };
      case "Term":
        return {
          label: "Term",
          value: "Term",
        };
      case "Privacy":
        return {
          label: "Privacy",
          value: "Privacy",
        };
      case "Contact Us":
        return {
          label: "Contact Us",
          value: "Contact Us",
        };
      case "Location":
        return {
          label: "Location",
          value: "Location",
        };
      case "KPR":
        return {
          label: "KPR",
          value: "KPR",
        };
      default:
        break;
    }
  };

  const handleContentClick = useCallback(
    (arg) => {
      const content = arg;
      let files = [];
      for (const f of content.content_file) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }
      setOriginalFiles(files);
      setAssetFiles(files);

      setContent({
        id: content.id,
        image: content.image,
        status: content.content_status && {
          label: content.content_status.name,
          value: content.content_status.id,
        },
        title: content.title,
        type: content.type && {
          label: content.type,
          value: content.type,
        },
        target_url: content.target_url,
        publishedat: content.publishedat,
        description: content.description,
        meta_keyword: content.meta_keyword,
        sort_order: content.sort_order,
        meta_description: content.meta_description,
        company: content.content_company && {
          label: content.content_company.name,
          value: content.content_company.id,
        },
        client: content.content_client && {
          label: content.content_client.name,
          value: content.content_client.id,
        },
        branch: content.content_branch && {
          label: content.content_branch.name,
          value: content.content_branch.id,
        },
        category: content.content_category && {
          label: content.content_category.name,
          value: content.content_category.id,
        },
        agent: content.content_agent && {
          label: content.content_agent.name,
          value: content.content_agent.id,
        },
        agency: content.content_agency && {
          label: content.content_agency.name,
          value: content.content_agency.id,
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      client: (content && content.client) || clientSelected,
      company: (content && content.company) || companySelected,
      image: (content && content.image) ?? "",
      category: (content && content.category) ?? "",
      status: (content && content.status) ?? "",
      title: (content && content.title) ?? "",
      type: (content && content.type) || { label: props.name, value: props.name },
      publishedat: (content && content.publishedat) ?? "",
      description: (content && content.description) ?? "",
      meta_keyword: (content && content.meta_keyword) ?? "",
      meta_description: (content && content.meta_description) ?? "",
      branch: (content && content.branch) || branchSelected,
      agent: (content && content.agent) ?? "",
      agency: (content && content.agency) ?? "",
      sort_order: (content && content.sort_order) || "0",
      target_url: (content && content.target_url) ?? "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Please Enter Title"),
      publishedat: Yup.string().required("Please Enter Tanggal"),
      type: Yup.object().required("Please Enter Category"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        let dataEdit = {
          id: content ? content.id : 0,
          image: values.image,
          categoryId: values.category.value,
          statusId: values.status.value,
          title: values.title,
          type: values.type.value,
          sort_order: values.sort_order,
          target_url: values.target_url,
          publishedat: values.publishedat,
          description: values.description,
          meta_keyword: values.meta_keyword,
          meta_description: values.meta_description,
          branchId: values.branch.value,
          companyId: values.company.value,
          clientId: values.client.value,
          agentId: values.agent.value,
          agencyId: values.agency.value,
          files: assetFiles.length > 0 ? assetFiles : [],
        };

        dispatch(onUpdateContent(dataEdit));
      } else {
        let dataAdd = {
          image: values.image,
          categoryId: values.category.value,
          statusId: values.status.value,
          title: values.title,
          type: values.type.value,
          sort_order: values.sort_order,
          target_url: values.target_url,
          publishedat: values.publishedat,
          description: values.description,
          meta_keyword: values.meta_keyword,
          meta_description: values.meta_description,
          branchId: values.branch.value,
          companyId: values.company.value,
          clientId: values.client.value,
          agentId: values.agent.value,
          agencyId: values.agency.value,
          files: assetFiles.length > 0 ? assetFiles : [],
        };

        dispatch(onAddNewContent(dataAdd));
      }

      validation.resetForm();
      toggle();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteContent(element.value));
    });
    checkall.checked = false;
  };

  // able Column
  const columns = useMemo(
    () => [
      {
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
        Cell: (cellProps) => {
          return <input type="checkbox" className="dataCheckbox form-check-input" value={cellProps.row.original.id} />;
        },
        id: "#",
      },
      {
        Header: " ",
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <Link
                to="#"
                // className={userType === "admin" || userType === "client" || userType === "company" ? "btn-icon btn btn-sm btn-light edit-item-btn" : userRole && userRole.split(",").indexOf("updateContent") !== -1 ? "btn-icon btn btn-sm btn-light edit-item-btn" : "btn-icon btn btn-sm btn-light edit-item-btn d-none"}
                className="btn-icon btn btn-sm btn-light edit-item-btn"
                onClick={() => {
                  let data = cellProps.row.original;
                  handleContentClick(data);
                }}
              >
                <i className="ri-edit-2-line fs-15"></i>
              </Link>
              <Link
                to="#"
                // className={userType === "admin" || userType === "client" || userType === "company" ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : userRole && userRole.split(",").indexOf("deleteContent") !== -1 ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"}
                className="btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                onClick={() => {
                  let data = cellProps.row.original;
                  onClickDelete(data);
                }}
              >
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Link>
            </div>
          );
        },
      },
      {
        Header: "Image",
        Cell: (cell) => {
          const img = cell.row.original.image === "" ? logo : `${api.MEDIA_URL}/media/${cell.row.original.image}`;
          return (
            <div className="avatar-lg p-1">
              <div className="avatar-title bg-light rounded-circle">
                <img src={img} alt="defaultImg" className="avatar-md rounded-circle object-cover" />
              </div>
            </div>
          );
        },
      },
      {
        Header: "Content Type",
        accessor: "type",
        filterable: true,
        Cell: (cell) => checkType(cell.row.original.type).label,
      },
      {
        Header: "Category",
        accessor: "content_category.name",
        filterable: true,
      },
      {
        Header: "Title",
        accessor: "title",
        filterable: true,
      },
      {
        Header: "Tanggal Publish",
        accessor: "expiredat",
        filterable: true,
        Cell: (data) => <>{handleValidDate(data.row.original.publishedat)},</>,
      },
      {
        Header: "Status",
        accessor: "content_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
    ],
    [handleContentClick, userRole, userType]
  );

  const defaultdate = () => {
    return moment().format("YYYY/MM/DD HH:mm:ss").toString();
  };

  const [filterDate, setFilterDate] = useState(null);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: contentList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };
  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var stat = status.value ? status.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: stat,
      type: props.name,
    };
    dispatch(onGetContent(param));
  }

  function handleLogoChange(event) {
    if (event.target.files && event.target.files[0]) {
      setLogo(URL.createObjectURL(event.target.files[0]));
      validation.setFieldValue("img", event.target.files[0]);
    }
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setContentList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    dispatch(resetContentState());
    dispatch(
      onGetContent({
        type: props.name,
      })
    );
  };

  document.title = "Data Content | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={contentList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteContent} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Kontent " pageTitle={`Kontent ${props.name}`} loading={loading}>
          {" "}
          <div className="flex-shrink-0">
            <button
              type="button"
              className={"btn btn-primary add-btn me-2"}
              id="create-btn"
              onClick={() => {
                setContent("");
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-building-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <button type="button" className="btn btn-success me-1" onClick={() => setIsExportCSV(true)}>
              <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
            </button>
            {/* <button className={"btn btn-soft-danger"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="contentList">
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-building-line me-1 align-bottom fs-14"></i> ALL CONTENT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={5}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Search...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3} className="col-xxl-3">
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Select created date"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(obj, str) => {
                                  setFilterDate(str);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>

                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered fullscreen={false} size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Data Content " : "Add Data Content "}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <Row>
                        <Col lg={8}>
                          <Row>
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="client-field" className="form-label">
                                Grup Usaha&nbsp;
                                {clientLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="client"
                                value={validation.values.client}
                                isDisabled={userType === "admin" || (userType === "client") === true ? false : true}
                                placeholder="Pilih Grup Usaha"
                                onChange={(e) => {
                                  validation.setFieldValue("client", e);
                                }}
                                options={clientList}
                              ></Select>
                            </div>
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="company-field" className="form-label">
                                Perusahaan&nbsp;
                                {companyLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="company"
                                value={validation.values.company}
                                placeholder="Pilih Perusahaan"
                                isDisabled={userType === "admin" || userType === "client" ? false : true}
                                onChange={(e) => {
                                  dispatch(setBranchSelect(null));
                                  dispatch(setCompanySelect(e));
                                  validation.setFieldValue("company", e);
                                }}
                                options={companyList}
                              ></Select>
                            </div>
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="branch-field" className="form-label">
                                Cabang&nbsp;
                                {branchLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="branch"
                                value={validation.values.branch}
                                placeholder="Select Branch"
                                isDisabled={branchList.length > 0 ? false : true}
                                onChange={(e) => {
                                  dispatch(setBranchSelect(e));
                                  validation.setFieldValue("branch", e);
                                }}
                                options={branchList}
                              ></Select>
                            </div>
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="type-field" className="form-label">
                                Content Type
                              </Label>
                              <Select
                                name="type"
                                isDisabled={true}
                                value={validation.values.type}
                                placeholder="Select Type"
                                onChange={(e) => {
                                  validation.setFieldValue("type", e);
                                }}
                                options={typeSelectData}
                                invalid={validation.touched.type && validation.errors.type ? true : false}
                              ></Select>
                              {validation.touched.type && validation.errors.type ? (
                                <p className="text-danger" type="invalid">
                                  {validation.errors.type}
                                </p>
                              ) : null}
                            </div>
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="date-field" className="form-label">
                                Tanggal Publish
                              </Label>
                              <Flatpickr
                                name="date-picker"
                                className="form-control"
                                placeholder="Select Tanggal Publish"
                                options={{
                                  enableTime: false,
                                  time_24hr: false,
                                  dateFormat: "Y/m/d",
                                }}
                                value={validation.values.publishedat ?? ""}
                                onChange={(o, e) => {
                                  validation.setFieldValue("publishedat", e);
                                }}
                              />
                              {validation.touched.publishedat && validation.errors.publishedat ? (
                                <small className="text-danger mt-1 fs-12" type="invalid">
                                  {validation.errors.publishedat}
                                </small>
                              ) : null}
                            </div>
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="category-field" className="form-label">
                                Content Category&nbsp;
                                {contentCategoryLoading ? (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                ) : (
                                  ""
                                )}
                              </Label>
                              <Select
                                name="Category"
                                value={validation.values.category}
                                placeholder="Select Category"
                                isDisabled={isDisabledUserType}
                                onChange={(e) => {
                                  validation.setFieldValue("category", e);
                                }}
                                options={contentCategoryList}
                              ></Select>
                            </div>
                          </Row>

                          <div className="mb-3">
                            <Label htmlFor="title-field" className="form-label">
                              Title
                            </Label>
                            <Input name="title" id="title-field" className="form-control" placeholder="Enter Title" type="input" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.title ?? ""} />
                            {validation.touched.title && validation.errors.title ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.title}
                              </p>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="title-field" className="form-label">
                              Content
                            </Label>

                            <CkEditor
                              data={validation.values.description}
                              onReady={(editor) => {
                                editor.editing.view.change((writer) => {
                                  writer.setStyle("height", "500px", editor.editing.view.document.getRoot());
                                });
                              }}
                              onChange={(value) => {
                                validation.setFieldValue("description", value);
                              }}
                            />
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="image" className="form-label">
                              Image
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                setMediaType("image");
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {validation.values.image !== "" ? (
                            <div className="border-bottom mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="me-2">
                                  <img src={validation.values.image === "" ? defaultImg : `${api.MEDIA_URL}/media/${validation.values.image}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                </div>

                                <div className="text-truncate">{validation.values.image}</div>
                                <div>
                                  <Link
                                    to="#"
                                    className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                    onClick={(e) => {
                                      validation.setFieldValue("image", "");
                                    }}
                                  >
                                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="taskFiles" className="form-label me-3">
                              Asset Files
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                setMediaType("files");
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {assetFiles.map((productFile, i) => {
                            if (productFile.isDeleted) {
                              return null;
                            } else {
                              return (
                                <div key={i} className="border-bottom mb-3">
                                  <div className="d-flex justify-content-between mb-3 align-items-center">
                                    <div className="me-2">
                                      <img src={productFile.filename === "" ? defaultImg : `${api.MEDIA_URL}/media/${productFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                    </div>

                                    <div className="text-truncate">{productFile.filename}</div>
                                    <div>
                                      <Link
                                        to="#"
                                        className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                        onClick={(e) => {
                                          // e.stopPropagation();
                                          handleDeleteFile(productFile);
                                        }}
                                      >
                                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}

                          <div className="mb-3">
                            <Label htmlFor="target_url-field" className="form-label">
                              Target URL
                            </Label>
                            <Input name="target_url" id="target_url-field" className="form-control" placeholder="Enter Target URL" type="input" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.target_url ?? ""} />
                            {validation.touched.target_url && validation.errors.target_url ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.target_url}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="meta_keyword-field" className="form-label">
                              Keyword
                            </Label>
                            <Input name="meta_keyword" id="meta_keyword-field" className="form-control" placeholder="Enter Keyword" type="input" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.meta_keyword ?? ""} />
                            {validation.touched.meta_keyword && validation.errors.meta_keyword ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.meta_keyword}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="meta_description-field" className="form-label">
                              Meta Description
                            </Label>
                            <Input name="meta_description" id="meta_description-field" className="form-control" placeholder="Enter Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.meta_description ?? ""} />
                            {validation.touched.meta_description && validation.errors.meta_description ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.meta_description}
                              </p>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="sort_order-field" className="form-label">
                              Sort Order
                            </Label>
                            <Input name="sort_order" id="sort_order-field" className="form-control" placeholder="Input No Urut" type="input" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.sort_order ?? ""} />
                            {validation.touched.sort_order && validation.errors.sort_order ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.sort_order}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="agency-field" className="form-label">
                              Agency
                            </Label>
                            <Select
                              name="agency"
                              value={validation.values.agency}
                              placeholder="Select Agency"
                              onChange={(e) => {
                                validation.setFieldValue("agency", e);
                              }}
                              options={agencyList}
                              invalid={validation.touched.agency && validation.errors.agency ? true : false}
                            ></Select>
                            {validation.touched.agency && validation.errors.agency ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.agency}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="agent-field" className="form-label">
                              Agent
                            </Label>
                            <Select
                              name="agent"
                              value={validation.values.agent}
                              placeholder="Select Agent"
                              onChange={(e) => {
                                validation.setFieldValue("agent", e);
                              }}
                              options={agentList}
                              invalid={validation.touched.agent && validation.errors.agent ? true : false}
                            ></Select>
                            {validation.touched.agent && validation.errors.agent ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.agent}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="active-status" className="form-label">
                              Status
                            </Label>
                            <Select
                              name="status"
                              value={validation.values.status}
                              validate={{ required: { value: true } }}
                              placeholder="Select Status"
                              onChange={(e) => {
                                validation.setFieldValue("status", e);
                              }}
                              onInputChange={(e) => {
                                // handleUnit(e);
                              }}
                              options={statusData}
                              invalid={validation.touched.status && validation.errors.status ? true : false}
                            ></Select>
                            {validation.touched.status && validation.errors.status && (
                              <p className="text-danger" type="invalid">
                                {validation.errors.status}
                              </p>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </ModalBody>
                    <div className="modal-footer mb3">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Add Content "}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Content;
